import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import * as gtag from "./lib/gtag";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import DriverSection from "./components/DriverSection";
import MerchantSection from "./components/MerchantSection";
import HowItWorksSection from "./components/HowItWorksSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import MerchantsPage from "./pages/MerchantsPage";
import MerchantDetailPage from "./pages/MerchantDetailPage";
import MerchantsMapPage from "./pages/MerchantsMapPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LandingPage = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  // 🔹 Track Google Analytics pageview setiap kali route berubah
  useEffect(() => {
    gtag.pageview(location.pathname + location.search);
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <DriverSection />
        <MerchantSection />
        <HowItWorksSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/merchants" element={<MerchantsPage />} />
          <Route path="/merchants/map" element={<MerchantsMapPage />} />
          <Route path="/merchants/:code" element={<MerchantDetailPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;